<template>
  <Card class="px-3 py-3 flex flex-col w-full gap-3">
    <template>
      <div class="flex justify-start items-center gap-2">
        <h1 class="font-bold text-lg leading-6 tracking-0015 text-flame">Section 4:</h1>
        <h2 class="font-bold text-lg leading-6 tracking-0015 text-darkPurple">
          Action Plan to Improve Performance
        </h2>
      </div>
      <div class="w-full flex p-2 rounded-md bg-yellow-50 border border-yellow-500">
        <div class="text-carrotOrange mx-auto self-center">
          <Icon size="xs" icon-name="icon-info" class="text-carrotOrange" />
        </div>
        <span class="flex text-sm mx-3">{{ message }}</span>
        <div class="text-carrotOrange mx-auto self-center">
          <Icon size="xs" icon-name="close" class="text-carrotOrange" />
        </div>
      </div>
    </template>
    <template>
      <Table
        :headers="headers"
        :items="items"
        aria-label="PerformanceSections"
        :has-number="true"
      >
        <template v-slot:item="{ item }">
          <div v-if="item.performanceIssue" class="flex justify-start items-center gap-2">
            <span class="text-darkPurple font-normal text-base leading-5 w-72">
              {{ item.data.performanceIssue === '' ? '----' :  item.data.performanceIssue}}
            </span>
            <div class="text-flame text-base cursor-pointer" @click="uploadModal = !uploadModal">
              <Icon icon-name="attachment" size="xs" />
            </div>
          </div>
          <div v-if="item.actionPlan" class="font-normal text-base leading-5 text-darkPurple">
            <Textarea v-model="item.data.actionPlan" :height="58" :disabled="item.data.performanceIssue === ''" />
          </div>
          <div v-if="item.responsibleParty" class="flex items-center whitespace-nowrap gap-3">
            <div class="flex flex-col justify-start items-start gap-2">
              <div v-for="(value, i) in item.data.responsibleParty" :key="`${value}-${i}`">
                <div class="flex gap-2 bg-ghostWhite p-2 rounded-md whitespace-nowrap">
                  <span class="text-sm leading-5 font-normal text-darkPurple">
                    {{ value }}
                  </span>
                  <Icon icon-name="close" />
                </div>
              </div>
            </div>
            <div v-if="item.data.responsibleParty.length <= 1">
              <Icon icon-name="math_plus" />
            </div>
          </div>
              <div
                v-if="item.dispPeriod"
                class="flex flex-col justify-center items-start gap-2 whitespace-nowrap mb-4 w-36"
              >
                <div
                  class="flex justify-between items-center gap-2 ml-5 whitespace-nowrap bg-ghostWhite px-3 py-2 rounded-md"
                  v-if="item.data.dispPeriod[0].startDate !== ''"
                >
                  <span class="text-darkPurple text-sm leading-5">
                    {{
                      item.data.dispPeriod[0].startDate !== ""
                        ? $DATEFORMAT(
                            new Date(item.data.dispPeriod[0].startDate),
                            "MMMM dd, yyyy"
                          )
                        : ""
                    }}
                  </span>
                  <Icon icon-name="close" class="text-darkPurple" />
                </div>
                <div
                  class="flex justify-between items-center gap-2 ml-5 whitespace-nowrap bg-ghostWhite px-3 py-2 rounded-md"
                  v-if="item.data.dispPeriod[1].endDate !== ''"
                >
                  <span class="text-darkPurple text-sm leading-5">
                    {{
                      item.data.dispPeriod[1].endDate !== ""
                        ? $DATEFORMAT(
                            new Date(item.data.dispPeriod[1].endDate),
                            "MMMM dd, yyyy"
                          )
                        : ""
                    }}
                  </span>
                  <Icon icon-name="close" class="text-darkPurple" />
                </div>
                <div
                  @click="setTimeline(item.data.dispPeriod, item.data.period)"
                  class="cursor-pointer ml-8"
                >
                  <Icon icon-name="icon-edit" class="text-blueCrayola" />
                </div>
              </div>
        </template>
      </Table>
    </template>
    <TimelineModal :open-modal="timelineModal" @selected="saveTimeline($event)" @close="timelineModal = false" />
    <UploadModal :open-modal="uploadModal" />
  </Card>
</template>

<script>
  import Card from "@scelloo/cloudenly-ui/src/components/card";
  import Table from "@scelloo/cloudenly-ui/src/components/table";
  import Textarea from "@scelloo/cloudenly-ui/src/components/text-area";
  import Icon from "@/components/Icon";
import UploadModal from "../Modals/UploadModal";
  import TimelineModal from "../Modals/TimelineModal";

  export default {
    name: "ESSImprovePerformance",
    components: {
      Card,
      Table,
      Textarea,
      Icon,
      TimelineModal,
      UploadModal
    },
    props: {
      items: {
        type: Array,
        required: true,
        default: (() => [])
      },
      message: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        uploadModal: false,
        timelineModal: false,
        headers: [
          { title: "Performance Issue", value: "performanceIssue", width: 32 },
          { title: "Improvement Action Plan(s)", value: "actionPlan" },
          { title: "Responsible Party(ies)", value: "responsibleParty" },
          { title: "Timeline", value: "dispPeriod" },
        ],
      current: {},
      payloadTimeline: {},
      };
  },

  methods: {
    setTimeline(disTimeline, timeline) {
      this.timelineModal = true;
      this.current = disTimeline;
      this.payloadTimeline = timeline;
    },

    formatDate(value) {
      const month = this.$DATEFORMAT(new Date(value), "MM");
      const day = this.$DATEFORMAT(new Date(value), "dd");
      const year = this.$DATEFORMAT(new Date(value), "yyyy");

      return `${year}-${month}-${day}`;
    },

    saveTimeline(value) {
      this.current[0].startDate = value.from;
      this.current[1].endDate = value.to;

      this.payloadTimeline[0].startDate = this.formatDate(value.from);
      this.payloadTimeline[1].endDate = this.formatDate(value.to);

      this.timelineModal = false;
    },

    setPayload() {
      const payload = this.items;

      this.$emit('set', payload);
    }
  },

  mounted() {
        setInterval(() => {
          this.setPayload();
        }, 10000);
  }

  };
</script>
<style lang="scss">
  .tracking-0015 {
    letter-spacing: 0.015em;
  }
  tbody {
    tr {
      background: white !important;
      border-bottom: 1px dashed #878E99 !important;
    }
    tr:nth-last-child(-n+2) {
      border-bottom: 0 !important;
    }
  }
  .width-272px {
    width: 272px;
  }
</style>

